import { FileCode2, ChartPie, Gift } from "lucide-react";
import { useLang } from "../i18n";

export default function Navbar() {
  const { lang, setLang, t } = useLang();

  const links = [
    { href: "#manoscritto", label: t.nav.about },
    { href: "#identita", label: t.nav.identity },
    { href: "#roadmap", label: t.nav.roadmap },
    { href: "#pionieri", label: t.nav.pioneers },
    { href: "#faq", label: t.nav.faq },
    { href: "#fondi", label: t.nav.funds },
  ];

  const quickButtons = [
    { href: "#mission", label: t.nav.mission },
    { href: "/whitepaper", label: "White Paper", external: true, accent: true },
    { href: "/smart-contract", label: t.nav.contract, external: true },
    { href: "/team", label: t.nav.team, external: true },
  ];

  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/70"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="h-20 sm:h-24 flex items-center justify-between gap-2 sm:gap-4">
          <a href="#manoscritto" className="flex items-center gap-2 sm:gap-3 shrink-0" data-testid="nav-logo-link">
            <img
              src="/ustp-logo-v2.png"
              alt="USTP logo"
              className="h-14 w-14 sm:h-20 sm:w-20 rounded-2xl object-cover ring-1 ring-slate-200 shadow-md"
            />
            <span className="leading-none min-w-0">
              <span className="block font-display font-bold tracking-tight text-slate-900 text-xl sm:text-2xl">USTP</span>
              <span className="block font-mono text-[8px] sm:text-[11px] tracking-[0.12em] sm:tracking-[0.18em] text-slate-500 mt-1">
                UNIVERSE SCORE TOKEN PROTOCOL
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="whitespace-nowrap text-sm font-medium text-slate-600 hover:text-sky-600 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/smart-contract"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-link-smart-contract"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-700 hover:text-sky-500 transition-colors"
            >
              <FileCode2 size={15} />
              {t.nav.contract}
            </a>
            <a
              href="/tokenomics"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-link-tokenomics"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-700 hover:text-sky-500 transition-colors"
            >
              <ChartPie size={15} />
              {t.nav.tokenomics}
            </a>
          </nav>

          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <a
              href="/ottieni-gratis"
              data-testid="nav-get-free"
              className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 shadow-md ring-2 ring-emerald-300/50 hover:bg-emerald-400 transition-colors animate-pulse"
            >
              <Gift size={15} />
              {lang === "en" ? "Get Free" : "Ottieni Gratis"}
            </a>
            <div
              data-testid="lang-toggle"
            className="flex items-center rounded-full border border-slate-200 bg-white p-0.5 shadow-sm shrink-0"
            role="group"
            aria-label="Language"
          >
            {["it", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-option-${l}`}
                onClick={() => setLang(l)}
                className={`px-2 sm:px-2.5 py-1 rounded-full font-mono text-[11px] font-bold uppercase transition-all ${
                  lang === l ? "bg-sky-600 text-white shadow" : "text-slate-500 hover:text-slate-800"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          </div>
        </div>

        <div
          data-testid="nav-quick-buttons"
          className="flex flex-nowrap items-stretch gap-1.5 sm:gap-2 pb-2.5 sm:pb-3 -mt-1"
        >
          {quickButtons.map((b) => (
            <a
              key={b.label}
              href={b.href}
              target={b.external ? "_blank" : undefined}
              rel={b.external ? "noopener noreferrer" : undefined}
              data-testid={`nav-quick-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex-1 inline-flex items-center justify-center text-center whitespace-nowrap rounded-full px-2 py-1.5 text-[11px] sm:text-xs font-bold bg-amber-400 text-slate-900 ring-1 ring-amber-500/30 hover:bg-amber-300 transition-colors shadow-sm"
            >
              {b.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}
